import React, { useState, useEffect } from 'react';
import { Table, Card, Badge, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import './Servicios.css';

const Servicios = ({
  citaData,
  onEmpleadoChange,
  onEliminarTratamiento,
  onEliminarProducto,
  onActualizarCitaData,
  onActualizarEstadoTicket
}) => {
  const [tratamientos, setTratamientos] = useState([]);
  const [productos, setProductos] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [descuentoAplicado, setDescuentoAplicado] = useState(false);
  const [mostrarCodigo, setMostrarCodigo] = useState(false);
  const [codigoDescuento, setCodigoDescuento] = useState("");
  const [validando, setValidando] = useState(false);
  const [errorCodigo, setErrorCodigo] = useState("");

  useEffect(() => {
    if (citaData?.tratamientos) setTratamientos(citaData.tratamientos);
    if (citaData?.productos) setProductos(citaData.productos);
    if (citaData?.resumen?.descuentoAplicado) setDescuentoAplicado(true);
  }, [citaData]);

  const handlePrecioChange = (tipo, index, nuevoPrecio) => {
    const precio = nuevoPrecio === '' ? '' : parseFloat(nuevoPrecio);
    let nuevosTratamientos = [...tratamientos];
    let nuevosProductos = [...productos];
    let nuevoCitaData = { ...citaData };

    if (tipo === 'Tratamiento') {
      nuevosTratamientos[index].precio = precio;
      setTratamientos(nuevosTratamientos);
      nuevoCitaData.tratamientos = nuevosTratamientos;
    } else {
      nuevosProductos[index].precio = precio;
      setProductos(nuevosProductos);
      nuevoCitaData.productos = nuevosProductos;
    }

    const totalTratamientos = nuevosTratamientos.reduce((sum, t) => sum + parseFloat(t.precio || 0), 0);
    const totalProductos = nuevosProductos.reduce((sum, p) => sum + parseFloat(p.precio || 0), 0);
    const total = totalTratamientos + totalProductos;

    const totalConDescuento = descuentoAplicado ? total * (1 - (citaData?.resumen?.porcentajeDescuento || 25)/100) : null;

    nuevoCitaData.resumen = {
      total,
      totalConDescuento,
      descuentoAplicado,
      totalTratamientos,
      totalProductos
    };

    onActualizarCitaData(nuevoCitaData);
    onActualizarEstadoTicket(nuevoCitaData);
  };

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/fichajeconEntrada`)
      .then(res => {
        const empleadosDisponibles = res.data.map(emp => ({
          id_empleado: emp.id_empleado,
          nombre: emp.nombre_empleado
        }));
        setEmpleados(empleadosDisponibles);
      })
      .catch(err => console.error("Error al cargar empleados:", err));
  }, []);

  const totalTratamientos = tratamientos.reduce((sum, t) => sum + parseFloat(t.precio || 0), 0);
  const totalProductos = productos.reduce((sum, p) => sum + parseFloat(p.precio || 0), 0);
  const total = totalTratamientos + totalProductos;
  const totalFinal = citaData?.resumen?.totalConDescuento != null
    ? parseFloat(citaData.resumen.totalConDescuento).toFixed(2)
    : total.toFixed(2);

  const itemsCombinados = [
    ...tratamientos.map((t, index) => ({ ...t, tipo: 'Tratamiento', index })),
    ...productos.map((p, index) => ({ ...p, tipo: 'Producto', index }))
  ];

  // Función para validar código con la API
  const validarCodigo = async () => {
    if (!codigoDescuento) return;
    setValidando(true);
    setErrorCodigo("");
  // Mostrar el código que se enviará
  console.log("Código que se va a validar:", codigoDescuento.trim());
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/validar/descuento`, {
        codigo: codigoDescuento.trim()
      });

      if (res.data.success && (res.data.activo !== false)) {
  aplicarDescuento(res.data.porcentaje || 25);
} else {
  setErrorCodigo("❌ Código inválido o inactivo");
}

    } catch (err) {
      console.error("Error validando código:", err);
      setErrorCodigo("⚠️ Error en la validación");
    } finally {
      setValidando(false);
    }
  };

  const aplicarDescuento = (porcentaje = 25) => {
    if (descuentoAplicado) return;

    const totalConDescuento = total * (1 - porcentaje / 100);
    const totalDescuento = total - totalConDescuento;

    const nuevoCitaData = {
      ...citaData,
      resumen: {
        ...citaData.resumen,
        total,
        totalConDescuento,
        totalDescuento,
        descuentoAplicado: true,
        porcentajeDescuento: porcentaje,
        totalTratamientos,
        totalProductos
      }
    };

    setDescuentoAplicado(true);
    setMostrarCodigo(false);
    onActualizarCitaData(nuevoCitaData);
    onActualizarEstadoTicket(nuevoCitaData);
  };

  return (
    <Card className="mb-4 servicios-container">
      <Card.Body>
        <Card.Title className="d-flex justify-content-between align-items-center">
          <span>Servicios y productos seleccionados</span>
          <Badge pill>{itemsCombinados.length}</Badge>
        </Card.Title>

        {itemsCombinados.length > 0 ? (
          <>
            <Table striped bordered hover responsive className="mt-3">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Tipo</th>
                  <th>Nombre</th>
                  <th>Precio</th>
                  <th>Empleado</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {itemsCombinados.map((item, i) => (
                  <tr key={`${item.tipo}-${i}`}>
                    <td>{i + 1}</td>
                    <td>{item.tipo}</td>
                    <td>{item.nombre}</td>
                    <td>
                      <input
                        type="number"
                        step="1"
                        min="0"
                        className="form-control form-control-sm"
                        value={item.precio ?? ''}
                        onChange={(e) =>
                          handlePrecioChange(item.tipo, item.index, e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <select
                        className="form-select form-select-sm"
                        value={item.id_empleado !== undefined ? String(item.id_empleado) : ""}
                        onChange={(e) =>
                          onEmpleadoChange(item.tipo, item.index, parseInt(e.target.value, 10))
                        }
                      >
                        <option value="">Seleccionar</option>
                        {empleados.map(emp => (
                          <option key={emp.id_empleado} value={String(emp.id_empleado)}>
                            {emp.nombre}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() =>
                          item.tipo === 'Tratamiento'
                            ? onEliminarTratamiento(item.index)
                            : onEliminarProducto(item.index)
                        }
                      >
                        X
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="5" className="text-end fw-bold">
                    {citaData?.resumen?.totalConDescuento != null
                      ? `Total con Descuento (${citaData.resumen.porcentajeDescuento || 25}%):`
                      : "Total:"}
                  </td>
                  <td className="fw-bold">€ {totalFinal}</td>
                </tr>
              </tfoot>
            </Table>

            <div className="text-end mt-3">
              {!descuentoAplicado && (
                <Button
                  variant="success"
                  onClick={() => setMostrarCodigo(!mostrarCodigo)}
                >
                  {mostrarCodigo ? "Cancelar" : "Aplicar descuento"}
                </Button>
              )}
              {descuentoAplicado && (
                <Button variant="secondary" disabled>
                  Descuento aplicado
                </Button>
              )}
            </div>

            {mostrarCodigo && !descuentoAplicado && (
              <div className="mt-3 p-3 border rounded bg-light">
                <Form.Group className="d-flex gap-2">
                  <Form.Control
                    type="text"
                    placeholder="Introduce el código"
                    value={codigoDescuento}
                    onChange={(e) => setCodigoDescuento(e.target.value)}
                  />
                  <Button
                    variant="primary"
                    onClick={validarCodigo}
                    disabled={validando || !codigoDescuento}
                  >
                    {validando ? "Validando..." : "Validar"}
                  </Button>
                </Form.Group>
                {errorCodigo && (
                  <div className="text-danger mt-2">{errorCodigo}</div>
                )}
              </div>
            )}
          </>
        ) : (
          <p>No hay tratamientos ni productos seleccionados</p>
        )}
      </Card.Body>
    </Card>
  );
};

export default Servicios;
